// extracted by mini-css-extract-plugin
export default {"header":"SortableColumnHeader-module__header__Ulsrl","active":"SortableColumnHeader-module__active__aRPl3","indicator":"SortableColumnHeader-module__indicator__PetWp"};